module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 133);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@splunk/themes");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("@splunk/ui-utils/id");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/Clickable");

/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* reexport */ src_Tooltip_Tooltip; });

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(2);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "lodash"
var external_lodash_ = __webpack_require__(4);

// EXTERNAL MODULE: external "@splunk/react-ui/Popover"
var Popover_ = __webpack_require__(17);
var Popover_default = /*#__PURE__*/__webpack_require__.n(Popover_);

// EXTERNAL MODULE: external "@splunk/react-ui/ScreenReaderContent"
var ScreenReaderContent_ = __webpack_require__(14);
var ScreenReaderContent_default = /*#__PURE__*/__webpack_require__.n(ScreenReaderContent_);

// EXTERNAL MODULE: external "@splunk/themes"
var themes_ = __webpack_require__(0);

// EXTERNAL MODULE: external "@splunk/ui-utils/id"
var id_ = __webpack_require__(10);

// EXTERNAL MODULE: external "@splunk/ui-utils/i18n"
var i18n_ = __webpack_require__(5);

// EXTERNAL MODULE: external "@splunk/react-icons/SVG"
var SVG_ = __webpack_require__(22);
var SVG_default = /*#__PURE__*/__webpack_require__.n(SVG_);

// CONCATENATED MODULE: ./src/Tooltip/InfoIcon.tsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }






function InfoCircle(props) {
  var _useSplunkTheme = Object(themes_["useSplunkTheme"])(),
      family = _useSplunkTheme.family,
      density = _useSplunkTheme.density;

  if (family === 'enterprise') {
    return /*#__PURE__*/external_react_default.a.createElement(SVG_default.a, _extends({
      screenReaderText: Object(i18n_["_"])('Info Circle'),
      viewBox: "0 0 24 24"
    }, props), /*#__PURE__*/external_react_default.a.createElement("path", {
      fill: "currentColor",
      d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13.2001 8.1999C13.2001 7.53716 12.6628 6.9999 12.0001 6.9999C11.3373 6.9999 10.8001 7.53716 10.8001 8.1999C10.8001 8.86264 11.3373 9.3999 12.0001 9.3999C12.6628 9.3999 13.2001 8.86264 13.2001 8.1999ZM11.0001 16.0094V11.9999C11.0001 11.4476 11.4478 10.9999 12.0001 10.9999C12.5524 10.9999 13.0001 11.4476 13.0001 11.9999V16.0094C13.0001 16.5617 12.5524 17.0094 12.0001 17.0094C11.4478 17.0094 11.0001 16.5617 11.0001 16.0094Z"
    }));
  }

  var size = density === 'compact' ? '20' : '24';
  return /*#__PURE__*/external_react_default.a.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: 'block'
    }
  }, /*#__PURE__*/external_react_default.a.createElement("path", {
    d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13.2003 8.1999C13.2003 7.53716 12.663 6.9999 12.0003 6.9999C11.3376 6.9999 10.8003 7.53716 10.8003 8.1999C10.8003 8.86264 11.3376 9.3999 12.0003 9.3999C12.663 9.3999 13.2003 8.86264 13.2003 8.1999ZM11.0005 16.0094V11.9999C11.0005 11.4476 11.4482 10.9999 12.0005 10.9999C12.5528 10.9999 13.0005 11.4476 13.0005 11.9999V16.0094C13.0005 16.5617 12.5528 17.0094 12.0005 17.0094C11.4482 17.0094 11.0005 16.5617 11.0005 16.0094Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

/* harmony default export */ var InfoIcon = (InfoCircle);
// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(3);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: external "@splunk/react-ui/Clickable"
var Clickable_ = __webpack_require__(11);
var Clickable_default = /*#__PURE__*/__webpack_require__.n(Clickable_);

// CONCATENATED MODULE: ./src/Tooltip/TooltipStyles.ts



var TooltipStyles_size = '16px';
var Styled = external_styled_components_default.a.span.withConfig({
  displayName: "TooltipStyles__Styled",
  componentId: "sc-67fvgm-0"
})(["", ";"], themes_["mixins"].reset('block'));
var StyledInline = external_styled_components_default.a.span.withConfig({
  displayName: "TooltipStyles__StyledInline",
  componentId: "sc-67fvgm-1"
})(["", ";"], themes_["mixins"].reset('inline-block'));
var StyledToggle = external_styled_components_default.a.span.withConfig({
  displayName: "TooltipStyles__StyledToggle",
  componentId: "sc-67fvgm-2"
})(["display:block;"]);
var StyledToggleInline = external_styled_components_default.a.span.withConfig({
  displayName: "TooltipStyles__StyledToggleInline",
  componentId: "sc-67fvgm-3"
})(["display:inline-block;"]);
var StyledContent = external_styled_components_default.a.div.withConfig({
  displayName: "TooltipStyles__StyledContent",
  componentId: "sc-67fvgm-4"
})(["padding:", ";font-size:", ";line-height:", ";user-select:none;"], Object(themes_["pick"])({
  enterprise: themes_["variables"].spacingHalf,
  prisma: Object(themes_["pickVariant"])('$isLabel', {
    "false": '12px 16px',
    "true": '4px 8px'
  })
}), Object(themes_["pick"])({
  enterprise: themes_["variables"].fontSizeSmall,
  prisma: 'inherit'
}), Object(themes_["pick"])({
  enterprise: '18px',
  prisma: Object(themes_["pickVariant"])('$isLabel', {
    "false": 'inherit',
    "true": '18px'
  })
}));
var StyledButton = external_styled_components_default()(Clickable_default.a).withConfig({
  displayName: "TooltipStyles__StyledButton",
  componentId: "sc-67fvgm-5"
})(["cursor:default;", " ", " &:focus{box-shadow:", ";}"], Object(themes_["pick"])({
  enterprise: Object(external_styled_components_["css"])(["display:inline-block;width:", ";height:", ";border:2px solid ", ";border-radius:", ";font-size:", ";font-weight:", ";line-height:calc(", " - 2px);text-align:center;color:", ";vertical-align:baseline;&:not([disabled]){&:hover{text-decoration:none;}}"], TooltipStyles_size, TooltipStyles_size, themes_["variables"].linkColor, TooltipStyles_size, themes_["variables"].fontSizeSmall, themes_["variables"].fontWeightSemiBold, TooltipStyles_size, themes_["variables"].linkColor),
  prisma: Object(external_styled_components_["css"])(["color:", ";border-radius:50%;display:inline-block;vertical-align:middle;&:hover,&:focus{color:", ";background:", ";}"], themes_["variables"].contentColorMuted, themes_["variables"].contentColorActive, themes_["variables"].interactiveColorOverlayHover)
}), Object(themes_["pick"])({
  prisma: {
    comfortable: Object(external_styled_components_["css"])(["padding:8px;"]),
    compact: Object(external_styled_components_["css"])(["padding:6px;"])
  }
}), themes_["variables"].focusShadow);

// CONCATENATED MODULE: ./src/Tooltip/Tooltip.tsx
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function Tooltip_extends() { Tooltip_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Tooltip_extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var propTypes = {
  children: external_prop_types_default.a.node,
  closeDelay: external_prop_types_default.a.number,
  content: external_prop_types_default.a.node,
  contentRelationship: external_prop_types_default.a.oneOf(['label', 'description']),
  defaultPlacement: external_prop_types_default.a.oneOf(['above', 'below', 'left', 'right', 'theme']),
  elementRef: external_prop_types_default.a.oneOfType([external_prop_types_default.a.func, external_prop_types_default.a.object]),
  inline: external_prop_types_default.a.bool,
  onRequestClose: external_prop_types_default.a.func,
  onRequestOpen: external_prop_types_default.a.func,
  open: external_prop_types_default.a.bool,
  openDelay: external_prop_types_default.a.oneOfType([external_prop_types_default.a.oneOf(['primary', 'secondary']), external_prop_types_default.a.number]),

  /** @private */
  splunkTheme: external_prop_types_default.a.object
};
var defaultProps = {
  closeDelay: 0,
  contentRelationship: 'description',
  defaultPlacement: 'theme',
  inline: true,
  openDelay: 'primary'
};

/**
 * The Tooltip component wraps arbitrary content to be displayed when the target element is hovered
 * or focused.
 */
var Tooltip_Tooltip = /*#__PURE__*/function (_Component) {
  _inherits(Tooltip, _Component);

  var _super = _createSuper(Tooltip);

  // @docs-props-type TooltipPropsBase
  function Tooltip(props) {
    var _this;

    _classCallCheck(this, Tooltip);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "ariaId", void 0);

    _defineProperty(_assertThisInitialized(_this), "controlledExternally", void 0);

    _defineProperty(_assertThisInitialized(_this), "popoverId", void 0);

    _defineProperty(_assertThisInitialized(_this), "timeout", void 0);

    _defineProperty(_assertThisInitialized(_this), "handleMount", function (el) {
      // Handle mouseenter and mouseleave with native events due to current issues with how they
      // are handled by react. See https://github.com/facebook/react/issues/4251,
      // https://github.com/facebook/react/issues/19419, and SUI-1232.
      if (el) {
        el.addEventListener('mouseenter', _this.handleMouseEnter);
        el.addEventListener('mouseleave', _this.handleMouseLeave);
      } else if (_this.state.anchor) {
        _this.state.anchor.removeEventListener('mouseenter', _this.handleMouseEnter);

        _this.state.anchor.removeEventListener('mouseleave', _this.handleMouseLeave);
      }

      _this.setState({
        anchor: el
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handlePopoverMount", function (el) {
      if (el) {
        el.addEventListener('mouseenter', _this.handleMouseEnterPopover);
        el.addEventListener('mouseleave', _this.handleMouseLeavePopover);
      } else if (_this.state.popoverEl) {
        _this.state.popoverEl.removeEventListener('mouseenter', _this.handleMouseEnterPopover);

        _this.state.popoverEl.removeEventListener('mouseleave', _this.handleMouseLeavePopover);
      }

      _this.setState({
        popoverEl: el
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function (e) {
      _this.handleRequestOpen(e, {
        reason: 'mouseEnterToggle'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnterPopover", function (e) {
      if (_this.state.lastCloseReason !== 'mouseLeavePopover') {
        _this.handleRequestOpen(e, {
          reason: 'mouseEnterPopover'
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function (e) {
      _this.handleRequestClose(e, {
        reason: 'mouseLeaveToggle'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeavePopover", function (e) {
      _this.handleRequestClose(e, {
        reason: 'mouseLeavePopover'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (e) {
      _this.handleRequestOpen(e, {
        reason: 'focusToggle'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (e) {
      _this.handleRequestClose(e, {
        reason: 'blurToggle'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handlePopoverOnRequestClose", function (data) {
      _this.handleRequestClose(null, data);
    });

    _defineProperty(_assertThisInitialized(_this), "handleRequestClose", function (e, data) {
      var closeDelay = _this.props.closeDelay;

      if (_this.timeout !== undefined) {
        clearTimeout(_this.timeout);
      }

      _this.timeout = setTimeout(function () {
        var _this$props$onRequest, _this$props;

        if (!_this.isControlled()) {
          _this.setState({
            open: false
          });
        }

        (_this$props$onRequest = (_this$props = _this.props).onRequestClose) === null || _this$props$onRequest === void 0 ? void 0 : _this$props$onRequest.call(_this$props, e, data);
      }, closeDelay);
    });

    _defineProperty(_assertThisInitialized(_this), "handleRequestOpen", function (e, data) {
      var openDelay = _this.props.openDelay;
      var normalDelay = openDelay === 'primary' ? 300 : 750;
      var finalDelay = typeof openDelay === 'number' ? openDelay : normalDelay;

      if (_this.timeout !== undefined) {
        clearTimeout(_this.timeout);
      }

      _this.timeout = setTimeout(function () {
        var _this$props$onRequest2, _this$props2;

        if (!_this.isControlled()) {
          _this.setState({
            open: true
          });
        }

        (_this$props$onRequest2 = (_this$props2 = _this.props).onRequestOpen) === null || _this$props$onRequest2 === void 0 ? void 0 : _this$props$onRequest2.call(_this$props2, e, data);
      }, finalDelay);
    });

    _this.controlledExternally = Object(external_lodash_["has"])(props, 'open');
    _this.popoverId = Object(id_["createDOMID"])('popover');
    _this.ariaId = Object(id_["createDOMID"])('aria-id');
    _this.state = {
      anchor: null,
      open: false,
      popoverEl: null,
      lastCloseReason: null
    };
    return _this;
  }

  _createClass(Tooltip, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (false) {}
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timeout !== undefined) {
        clearTimeout(this.timeout);
      }
    }
  }, {
    key: "isControlled",
    value: function isControlled() {
      return this.controlledExternally;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          content = _this$props3.content,
          defaultPlacement = _this$props3.defaultPlacement,
          elementRef = _this$props3.elementRef,
          inline = _this$props3.inline,
          onRequestClose = _this$props3.onRequestClose,
          onRequestOpen = _this$props3.onRequestOpen,
          open = _this$props3.open,
          splunkTheme = _this$props3.splunkTheme,
          contentRelationship = _this$props3.contentRelationship,
          otherProps = _objectWithoutProperties(_this$props3, ["children", "content", "defaultPlacement", "elementRef", "inline", "onRequestClose", "onRequestOpen", "open", "splunkTheme", "contentRelationship"]);

      var anchor = this.state.anchor;
      var hasContent = !!content;
      var openRender = !!anchor && this.isControlled() ? open : hasContent && this.state.open;
      var StyledComp = inline ? StyledInline : Styled;
      var StyledToggleComp = inline ? StyledToggleInline : StyledToggle;
      var isPrisma = splunkTheme.family === 'prisma';
      var placement = isPrisma ? 'below' : 'above';
      var cloneProps;

      if (contentRelationship === 'label') {
        cloneProps = {
          labelledBy: this.ariaId,
          'aria-labelledby': this.ariaId // not all components support the `labelledBy` prop.

        };
      } else if (contentRelationship === 'description') {
        cloneProps = {
          describedBy: this.ariaId,
          'aria-describedby': this.ariaId
        };
      }

      return /*#__PURE__*/external_react_default.a.createElement(StyledComp, Tooltip_extends({
        "data-test": "tooltip",
        "data-test-open": openRender,
        "data-test-popover-id": this.popoverId,
        ref: elementRef
      }, otherProps), /*#__PURE__*/external_react_default.a.createElement(StyledToggleComp, {
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        ref: this.handleMount,
        "data-test": "toggle"
      }, hasContent && /*#__PURE__*/Object(external_react_["isValidElement"])(children) ? /*#__PURE__*/Object(external_react_["cloneElement"])(children, cloneProps) : children, hasContent && !children && /*#__PURE__*/external_react_default.a.createElement(StyledButton, {
        "aria-describedby": this.ariaId
      }, isPrisma ? /*#__PURE__*/external_react_default.a.createElement(InfoIcon, {
        hideDefaultTooltip: true,
        screenReaderText: Object(i18n_["_"])('More info'),
        style: {
          height: '22px',
          width: '22px'
        }
      }) : /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, /*#__PURE__*/external_react_default.a.createElement("span", {
        "aria-hidden": "true"
      }, "?"), /*#__PURE__*/external_react_default.a.createElement(ScreenReaderContent_default.a, null, Object(i18n_["_"])('More info')))), hasContent && /*#__PURE__*/external_react_default.a.createElement(ScreenReaderContent_default.a, {
        id: this.ariaId
      }, content)), /*#__PURE__*/external_react_default.a.createElement(Popover_default.a, {
        role: "tooltip",
        align: "center",
        anchor: anchor,
        appearance: "inverted",
        closeReasons: ['offScreen', 'escapeKey'],
        defaultPlacement: defaultPlacement === 'theme' ? placement : defaultPlacement,
        id: this.popoverId,
        open: openRender,
        onRequestClose: this.handlePopoverOnRequestClose,
        elementRef: this.handlePopoverMount
      }, /*#__PURE__*/external_react_default.a.createElement(StyledContent, {
        $isLabel: contentRelationship === 'label'
      }, content)));
    }
  }]);

  return Tooltip;
}(external_react_["Component"]);

_defineProperty(Tooltip_Tooltip, "propTypes", propTypes);

_defineProperty(Tooltip_Tooltip, "defaultProps", defaultProps);

var TooltipWithTheme = Object(themes_["withSplunkTheme"])(Tooltip_Tooltip);
TooltipWithTheme.propTypes = Tooltip_Tooltip.propTypes;
/* harmony default export */ var src_Tooltip_Tooltip = (TooltipWithTheme);
// CONCATENATED MODULE: ./src/Tooltip/index.ts



/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/ScreenReaderContent");

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/Popover");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 22:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-icons/SVG");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@splunk/ui-utils/i18n");

/***/ })

/******/ });